import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TOKEN_CONTAINER_DROPDOWN: `${cleanedFilename(
    __filename,
  )}-token-container-dropdown`,
  DESCRIPTION: `${cleanedFilename(__filename)}-description`,
};
